import { CREATE_ORDER, RESET_ORDER, GET_ORDERS, GET_PAST_ORDER, CLEAR_PAST_ORDER, UPDATE_CUSTOMER_ID_ORDER, VALIDATE_ORDER_REQUEST, PLACE_ORDER_LOADING, MODIFY_TIPPING_TOTAL, } from '../../constants';
export function createOrderAction(payload) {
    return {
        type: CREATE_ORDER,
        payload,
    };
}
export function resetOrderAction() {
    return {
        type: RESET_ORDER,
    };
}
export function getOrdersAction(payload) {
    return {
        type: GET_ORDERS,
        payload,
    };
}
export function getPastOrderAction(payload) {
    return {
        type: GET_PAST_ORDER,
        payload,
    };
}
export function clearPastOrderAction(payload) {
    return {
        type: CLEAR_PAST_ORDER,
        payload,
    };
}
export function updateCustomerIDforOrder(payload) {
    return {
        type: UPDATE_CUSTOMER_ID_ORDER,
        payload,
    };
}
export function validateOrderAction(payload) {
    return {
        type: VALIDATE_ORDER_REQUEST,
        payload,
    };
}
export function setPlaceOrderLoading(isLoading) {
    return {
        type: PLACE_ORDER_LOADING,
        isLoading,
    };
}
export function modifyTippingTotal(payload) {
    return {
        type: MODIFY_TIPPING_TOTAL,
        payload,
    };
}
